import React from 'react';

const NebulaUltraMetadataFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaUltraMetadataModalRegistry = {
    personalize_nebulaUltraMetadataId: NebulaUltraMetadataFormModal
};
export default nebulaUltraMetadataModalRegistry;
